import React, { memo, ReactElement, useCallback, useEffect } from "react";
import classNames from "classnames";

import { replaceText } from "@core-ui/helpers/HtmlFormatter";
import { isEmpty } from "@core-ui/helpers/Utils";
import { RenderingDetails } from "@swiggy-private/cart-types";
import { ElementVisibilitySensor } from "@swiggy-private/dls-web-core/dist/components/ElementVisibilitySensor";

import styles from "../BillDetailItem.scss";
import { LINE_ITEM_LOGO_ID } from "@core-ui/constants/BillDetails";

export interface TitleProps {
    isInTooltip?: boolean;
    itemData: RenderingDetails;
    onImpressionBillTotalGrouping?: () => void;
    onImpressionBillTotalGroupingActual?: () => void;
}

export const BILL_DETAILS_CONTAINER_ID = "bill-details-container";
export const BILL_DETAILS_TITLE_KEY = "bill_heading";

const Title = ({
    itemData,
    isInTooltip = false,
    onImpressionBillTotalGrouping,
    onImpressionBillTotalGroupingActual,
}: TitleProps): ReactElement | null => {
    useEffect(() => {
        if (itemData.key === BILL_DETAILS_TITLE_KEY) {
            onImpressionBillTotalGrouping?.();
        }
    }, [onImpressionBillTotalGrouping, itemData.key]);

    const onVisivilityChange = useCallback(
        isVisible => {
            if (isVisible) {
                onImpressionBillTotalGroupingActual?.();
            }
        },
        [onImpressionBillTotalGroupingActual],
    );

    const displayText = itemData.display_text;
    if (isEmpty(displayText)) {
        return null;
    }

    const className = classNames({
        [styles.title]: true,
        [styles.titleInTooltip]: isInTooltip,
    });

    const getID = itemData.key === BILL_DETAILS_TITLE_KEY ? BILL_DETAILS_CONTAINER_ID : undefined;

    return (
        <ElementVisibilitySensor senseOnce onVisibilityChange={onVisivilityChange}>
            <div className={className} id={getID}>
                {itemData?.meta?.logoId
                    ? replaceText(
                          displayText?.replace(LINE_ITEM_LOGO_ID, itemData?.meta?.logoId),
                          styles.displayTextLogoTitle,
                      )
                    : displayText}
            </div>
        </ElementVisibilitySensor>
    );
};

export default memo(Title);
